import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";

export function BirthdayImageField({ shop, onSaved }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [v, setV] = useState(0);
  const link = shop?.birthday_link;
  const upload = async (f) => {
    if (!f) { return; }
    if (!/^image\/(png|jpe?g)$/.test(f.type)) { toast.error("Envie uma imagem JPG ou PNG"); return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      await api.post("/shop-settings/birthday-image", fd);
      toast.success("Imagem salva"); setV(Date.now()); await onSaved?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); if (ref.current) { ref.current.value = ""; } }
  };
  const remove = async () => {
    setBusy(true);
    try { await api.delete("/shop-settings/birthday-image"); toast.success("Imagem removida"); await onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="birthday-image-field" className="rounded-lg border border-zinc-800 bg-zinc-950 p-3 space-y-2">
      <div className="text-xs font-bold text-zinc-300">Imagem de aniversário <span className="font-normal text-zinc-500">(opcional, JPG ou PNG)</span></div>
      {link ? (
        <img data-testid="birthday-image-preview" src={`${link}/img.jpg?v=${v}`} alt="Imagem de aniversário" className="max-h-40 rounded-md border border-zinc-800" />
      ) : <p className="text-[11px] text-zinc-500">Com imagem, o link dela entra no fim da mensagem e o WhatsApp mostra a prévia.</p>}
      <input ref={ref} type="file" accept="image/png,image/jpeg" className="hidden" data-testid="birthday-image-input" onChange={(e) => upload(e.target.files?.[0])} />
      <div className="flex gap-2">
        <Button type="button" size="sm" variant="outline" disabled={busy} data-testid="birthday-image-upload" onClick={() => ref.current?.click()} className="bg-zinc-900 border-zinc-800">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4 mr-1" />} {link ? "Trocar imagem" : "Enviar imagem"}
        </Button>
        {link && <Button type="button" size="sm" variant="ghost" disabled={busy} data-testid="birthday-image-remove" onClick={remove} className="text-red-400"><Trash2 className="h-4 w-4 mr-1" /> Remover</Button>}
      </div>
    </div>
  );
}
